import { render, staticRenderFns } from "./IconShoppingBag.vue?vue&type=template&id=17419fa1&scoped=true&"
import script from "./IconShoppingBag.vue?vue&type=script&lang=js&"
export * from "./IconShoppingBag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17419fa1",
  null
  
)

export default component.exports